"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const select_1 = __importDefault(require("./select/select"));
const status_1 = require("../constants/status");
const dumblabel_1 = __importDefault(require("../dumblabel"));
const errorMessage_1 = __importDefault(require("../errorMessage/errorMessage"));
const Dropdown = props => {
    const [blurCounter, setBlurCount] = react_1.default.useState(0);
    const generatedId = lodash_uniqueid_1.default('fslctc_');
    const { onValueChange, children, label, id, invalid, selectRef, disabled, required, errorMessage, value, hideLabel } = props;
    const error = value === '' && blurCounter > 1 && required;
    const handleFocus = () => {
        setBlurCount(required ? blurCounter + 1 : blurCounter);
    };
    const labelProps = {
        forId: id || generatedId,
        text: label,
        required,
        inputHasFocus: false,
        inputHasValue: false,
        hideLabel
    };
    const selectProps = {
        id: id || generatedId,
        placeholder: label,
        onChange: e => onValueChange(e),
        status: error || invalid ? status_1.STATUS_INVALID : null,
        selectRef: selectRef,
        disabled: disabled,
        onFocus: handleFocus
    };
    return (jsx_runtime_1.jsxs(dumblabel_1.default, Object.assign({}, labelProps, { children: [jsx_runtime_1.jsx(select_1.default, Object.assign({}, selectProps, { children: children }), void 0),
            invalid && !!errorMessage && jsx_runtime_1.jsx(errorMessage_1.default, { text: errorMessage }, void 0)] }), void 0));
};
exports.Dropdown = Dropdown;
exports.Dropdown.propTypes = {
    children: prop_types_1.default.node.isRequired,
    label: prop_types_1.default.string.isRequired,
    onValueChange: prop_types_1.default.func.isRequired,
    errorMessage: prop_types_1.default.string,
    selectRef: prop_types_1.default.func,
    invalid: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    value: prop_types_1.default.string,
    hideLabel: prop_types_1.default.bool,
    id: prop_types_1.default.string
};
exports.Dropdown.defaultProps = {
    selectRef: () => { },
    errorMessage: '',
    invalid: false,
    disabled: false,
    required: false,
    value: '',
    hideLabel: false,
    id: ''
};
exports.default = exports.Dropdown;
//# sourceMappingURL=dropdown.js.map